import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// What the endpoint accepts in one request. An offer may hold far more variants than this, so the
// ask is split and the parts run together - three at a time, as the collection counts do, to leave
// the shop's cost bucket to the imports that share it.
const SIDS_PER_REQUEST = 250;
const CONCURRENT_REQUESTS = 3;

const chunk = (items, size) => items.reduce(
  (chunks, item, index) => (index % size ? chunks : [...chunks, items.slice(index, index + size)]),
  []
);

function* fetchChunk(sids, signal) {
  const { data } = yield call(fetch, {
    api: api.shopify.variant_stock,
    data: { sids },
    signal
  });

  return data?.results || [];
}

function* getShopifyVariantStock({ payload: { sids, signal, onSuccess, onError, handledErrors } }) {
  try {
    const batches = chunk(sids, SIDS_PER_REQUEST);
    const results = [];

    for (let i = 0; i < batches.length; i += CONCURRENT_REQUESTS) {
      const wave = yield all(batches.slice(i, i + CONCURRENT_REQUESTS).map(part => call(fetchChunk, part, signal)));
      wave.forEach(part => results.push(...part));
    }

    // Reported once, with every sid asked about, so a caller that replaces its state from this
    // never sees a fraction of what it asked for.
    yield put(actions.getShopifyVariantStockDone({ results }));
    onSuccess && onSuccess(results);
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyVariantStockFailed,
      onError,
      handledErrors,
      endpoint: api.shopify.variant_stock.url
    });
  }
}

export const getShopifyVariantStockSaga = takeEvery(types.GET_SHOPIFY_VARIANT_STOCK_REQUEST, getShopifyVariantStock);
